import { Tabs } from "@jhool-io/fe-components";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { cn } from "../../../../utils/helpers";
import InvoiceNotes from "../../../billing/components/InvoiceNotes/InvoiceNotes";
import BackLink from "../../../../components/BackLink/BackLink";
import HarmonizedView from "../../../../shared-ui/HarmonizedView/HarmonizedView";
import { useFetchSessionNote } from "../../../../hooks/queries/note";
import PaymentTabWrapper from "../../../billing/components/PaymentTabWrapper/PaymentTabWrapper";
import { useFetchRemitClaims } from "../../../remits/hooks/remits.queries";
import { getClaimsListNavigateUrl } from "../../helpers/claims.helper";
import RemitsWrapper from "../../../remits/components/RemitsWrapper/RemitsWrapper";
import NoteItemsWrapper from "../../../notes/components/NoteItemsWrapper/NoteItemsWrapper";
import ClaimsWrapper from "../ClaimsWrapper/ClaimsWrapper";

interface ViewClaimProps {
    isEmbedded?: boolean;
}

export default function ViewClaim({ isEmbedded = false }: ViewClaimProps) {
    const [searchParams, setSearchParams] = useSearchParams();
    const params = useParams();
    const { clientId, noteId } = params;
    const defaultActiveKey = searchParams.get("claims_sub_tab");
    const navigate = useNavigate();

    const claimsListUrl = getClaimsListNavigateUrl();

    const { data } = useFetchSessionNote(
        clientId as string,
        noteId as string,
        Boolean(clientId) && Boolean(noteId)
    );

    // fetch single remit data
    const remitsData = useFetchRemitClaims({
        note_id: noteId,
    });

    const handleSetTabInUrl = (claimsSubTab: string) => {
        searchParams.set("claims_sub_tab", claimsSubTab);
        setSearchParams(searchParams);
    };

    const tabItems = [
        {
            key: "notes",
            label: "Session Note",
            children: (
                <div>
                    <NoteItemsWrapper />
                </div>
            ),
            onClick: () => handleSetTabInUrl("notes"),
        },
        {
            key: "claims",
            label: "Claims",
            children: (
                <div>
                    <ClaimsWrapper />
                </div>
            ),
            onClick: () => handleSetTabInUrl("claims"),
        },
        {
            key: "payments",
            label: "Payments History",
            children: (
                <div>
                    <PaymentTabWrapper />
                </div>
            ),
            onClick: () => handleSetTabInUrl("payments"),
            disabled: data?.data.is_archived && !data?.data.invoice_id,
        },
        {
            key: "remit",
            label: "Remits",
            children: (
                <div>
                    <RemitsWrapper />
                </div>
            ),
            onClick: () => handleSetTabInUrl("remit"),
            disabled:
                !remitsData?.data?.data || remitsData?.data?.data?.length === 0,
        },
    ];

    return (
        <div>
            {!isEmbedded && (
                <div className="mb-[--spacing-items]">
                    <BackLink onClick={() => navigate(claimsListUrl)} />
                </div>
            )}
            <div className="flex items-stretch max-[1100px]:flex-col gap-[--spacing-items]">
                <div className="w-[70%] max-[1100px]:w-full max-[1100px]:mb-10">
                    <HarmonizedView />
                </div>
                <div className="w-[30%] max-[1100px]:w-full max-[1100px]:ml-0">
                    <InvoiceNotes invoiceId={data?.data.invoice_id as string} />
                </div>
            </div>

            <div className="pt-[--spacing-header]">
                <Tabs
                    items={tabItems}
                    className={cn("!w-[100%] !items-end")}
                    defaultActiveKey={defaultActiveKey || "claims"}
                    size="small"
                    key={defaultActiveKey}
                />
            </div>
        </div>
    );
}
